import { DashboardIcon, Logout } from "Assets/index";
import { LoadBoardICon } from "Assets/index";
import { MybidsIcon } from "Assets/index";
import { MyloadsIcon } from "Assets/index";
import { CapacitySearchIcon } from "Assets/index";
import { AddLoadIcon } from "Assets/index";
import { NotificationIcon } from "Assets/index";
import { SmsIcon } from "Assets/index";
import { UnitsIcon } from "Assets/index";
import { AccountingIcon } from "Assets/index";
import { SettingsIcon } from "Assets/index";
import { clear } from "Service/storage";

export const sidebar = [
  { icon: DashboardIcon, name: "Dashboard", link: "/dashboard" },
  { icon: LoadBoardICon, name: "Load Board", link: "/loads" },
  { icon: MybidsIcon, name: "My Bids", link: "/my-bids" },
  { icon: MyloadsIcon, name: "My Loads", link: "/my-loads" },
  { icon: CapacitySearchIcon, name: "Capacity Search", link: "/capacity" },
  { icon: AddLoadIcon, name: "Add Load", link: "/addload" },
  { icon: NotificationIcon, name: "Notification", link: "/notification" },
  { icon: SmsIcon, name: "Chat", link: "/chat" },
  {
    icon: UnitsIcon,
    name: "Units",
    link: "/units",

    subNav: [
      {
        name: "Users",
        link: "/units/users",
      },
      {
        name: "Vehicles",
        link: "/units/vehicles",
      },
      {
        name: "Drivers",
        link: "/units/drivers",
      },
      {
        name: "Owners",
        link: "/units/owners",
      },
      {
        name: "Partners",
        link: "/units/partners",
      },
      {
        name: "Delievery Map",
        link: "/units/delievery-map",
      },
    ],
  },
  {
    icon: AccountingIcon,
    name: "Accounting",
    link: "/accounting",

    subNav: [
      {
        name: "Income",
        link: "/accounting/income",
      },
      {
        name: "List of Loads",
        link: "/accounting/list-of-loads",
      },
      {
        name: "Brokers",
        link: "/accounting/brokers",
      },
      {
        name: "Owners",
        link: "/accounting/owners",
      },
      {
        name: "Dispatchers",
        link: "/accounting/dispatchers",
      },
    ],
  },
  { icon: SettingsIcon, name: "Settings", link: "/settings" },
  { icon: Logout, name: "Logout", link: "/sign-in" },
];
